/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requested_Documents_Existing_Confirm_TitleInputs */

const en_task_requested_documents_existing_confirm_title = /** @type {(inputs: Task_Requested_Documents_Existing_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document already on file`)
};

const pt_br2_task_requested_documents_existing_confirm_title = /** @type {(inputs: Task_Requested_Documents_Existing_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento já adicionado`)
};

/**
* | output |
* | --- |
* | "Document already on file" |
*
* @param {Task_Requested_Documents_Existing_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requested_documents_existing_confirm_title = /** @type {((inputs?: Task_Requested_Documents_Existing_Confirm_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requested_Documents_Existing_Confirm_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requested_documents_existing_confirm_title(inputs)
	return pt_br2_task_requested_documents_existing_confirm_title(inputs)
});